// External library imports
// import { Rocket } from "lucide-react";

// Constants
const BRAND_NAME = "One Account";

/**
 * AppLogo Component
 * Renders the application logo with a rocket icon and branded text
 */
export const AppLogo = () => {
  return (
    <div
      className="flex items-center gap-2"
      role="banner"
      aria-label="Application logo"
    >
      <svg viewBox="0 0 171.653 146" xmlns="http://www.w3.org/2000/svg" width="28.22" height="24" fill="none">
	      <path id="lingke logo" d="M73.0904 62.8548L73.0904 39.6849C73.0904 36.8485 74.8328 34.304 77.4769 33.2795L162.097 0.471037C166.592 -1.27162 171.437 2.03602 171.451 6.85661L171.487 19.4666C171.487 22.2977 169.766 24.844 167.13 25.8799L73.0904 62.8548ZM26.3599 20.3141C26.3599 9.05354 34.9706 2.42976 44.2442 2.42976C53.5178 2.42976 62.7906 10.3783 62.7906 20.3141C62.7906 30.2499 54.1799 38.8605 44.2442 38.8605C34.3085 38.8605 26.3599 31.5749 26.3599 20.3141ZM73.0904 62.8548L73.0904 90.2017L4.46258 64.5242C1.77865 63.5204 0 60.9553 0 58.0896L0 44.9525C0 40.1392 4.82102 36.8184 9.31803 38.5334L73.0904 62.8548ZM150.337 61.1743L162.351 56.6255C166.845 54.9243 171.653 58.2451 171.653 63.0506L171.653 123.884L171.511 139.188C171.467 143.886 166.826 147.155 162.388 145.615L73.4168 114.733L73.0904 90.2017L145.899 114.733L145.899 67.5994C145.899 64.7432 147.666 62.1859 150.337 61.1743ZM17.4942 118.32L17.4942 105.078C17.4942 100.358 22.1434 97.0442 26.6046 98.5831L73.4168 114.733L73.2029 132.682C73.1471 137.355 68.5442 140.609 64.1208 139.104L22.1512 124.823C19.3671 123.876 17.4942 121.261 17.4942 118.32Z" fill="rgb(0,0,0)" fill-rule="evenodd" />
      </svg>

      <span
        className="bg-gradient-to-r from-stone-950 to-neutral-950 bg-clip-text text-xl font-bold text-transparent"
        aria-label={BRAND_NAME}
      >
        {BRAND_NAME}
      </span>
    </div>
  );
};
